import { WIS_EVENTS } from '../constants';

export default function handleHeadsetEvents(message) {
    const { key } = message.msgdata || {};

    switch (key) {
    case 'mute': {
        APP.wildix.eventEmitter.emit(WIS_EVENTS.MUTE);
        break;
    }
    case 'unmute': {
        APP.wildix.eventEmitter.emit(WIS_EVENTS.UNMUTE);
        break;
    }
    case 'hangup': {
        APP.wildix.eventEmitter.emit(WIS_EVENTS.HANGUP);
        break;
    }
    default: {
        break;
    }
    }
}
